/*
 * @Author: bbqin
 * @Date: 2021-09-06 09:53:42
 * @LastEditTime: 2022-08-24 17:01:01
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\adapters\router.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React from 'react';
// import { ViewModel } from '@platform/api';
import { getCacheExtendJson, analysisPageEventExtend } from '../model/free';
import * as constant from '../const';

const ModuleCacheName = constant.moduleCacheName;

const routerExtend = ({ match }) => {
    let freeExtendCacheJson = getCacheExtendJson();
    if (freeExtendCacheJson) {
        return analysisPageEventExtend(freeExtendCacheJson, 'localExtendRouter', this, undefined, match);
    } else if (window.ViewModel) {
        let extendCache = window.ViewModel.getData(ModuleCacheName);
        if (extendCache) {
            let router;
            for (let pop in extendCache) {
                // 同一个页面有多个createPage导致前面一个执行时  事件丢失
                if (extendCache[pop] && extendCache[pop].localExtendRouter) {
                    router = extendCache[pop].localExtendRouter;
                }
            }

            return router ? router(match) : <h1>未找到localExtendRouter, 请检查下扩展开发配置!</h1>;
        }
        // console.log('客开的路由扩展', ViewModel.localExtendRouter);
        // return ViewModel.localExtendRouter ? ViewModel.localExtendRouter(match) : <h1>Hello {match.params.extend}!</h1>;
    }
    return null;

};
export default routerExtend;